export default __webpack_public_path__ + "static/media/ibcae.994cf603.png";